import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  searchValue: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor() {}
}
